import { ConditionEqualityType } from "../../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { DateMode } from "./dateFilterState.ts";
import { DateType } from "./dateFilterState.ts";

export const equalityOptions = [
  { caption: "Equal =", value: ConditionEqualityType.Equal },
  { caption: "Less than <", value: ConditionEqualityType.LessThan },
  { caption: "Less than or equal to ≤", value: ConditionEqualityType.LessThanOrEqual },
  { caption: "Greater than >", value: ConditionEqualityType.GreaterThan },
  { caption: "Greater than or equal to ≥", value: ConditionEqualityType.GreaterThanOrEqual },
];

export const modeOptions: { value: DateMode; caption: string }[] = [
  { value: "exact", caption: "Exact Date" },
  { value: "reference", caption: "Reference Date" },
];

export const periodOptions = [
  { value: DateType.Date, caption: "Day" },
  { value: DateType.Period, caption: "Period" },
];
